import { useCurrentDossierCtx } from '@europrocurement/l2d-modules/modules/Dossiers/providers/CurrentDossierProvider';
import React, { ReactNode } from 'react';
import { DossierDocumentsProvider } from './DossierDocumentsProvider';

type Props = { children: ReactNode };

/**
 * Reads sibling dossier IDs from CurrentDossierProvider and wraps children
 * with DossierDocumentsProvider scoped to all siblings.
 */
const DossierDocumentsProviderWrapper: React.FunctionComponent<Props> = function ({ children }) {
    const { siblings } = useCurrentDossierCtx();
    const dossierIds = siblings?.map((d) => d.id as number) ?? [];

    return (
        <DossierDocumentsProvider
            autoload
            dossierIds={dossierIds}
        >
            {children}
        </DossierDocumentsProvider>
    );
};

export default DossierDocumentsProviderWrapper;
